import { CONTACT } from '../../../constants';
import { formatPhoneHref } from '../../../utils/formatters';
import './ProjectEnquiryCTA.css';

export default function ProjectEnquiryCTA({ project }) {
  const { name, enquiry } = project;
  const phone = enquiry?.phone || CONTACT.phone;
  const whatsappHref = enquiry?.whatsappHref || CONTACT.whatsappHref;

  return (
    <section id="enquire" className="pd-enquire">
      <div className="pd-enquire__inner">
        <h2 className="pd-enquire__title">
          Interested in <em>{name}</em>?
        </h2>
        <p className="pd-enquire__body">
          Speak with our property advisory team to learn more about available
          units, pricing, payment plans and inspections.
        </p>

        <div className="pd-enquire__actions">
          <a href="/#contact" className="btn btn--light">Request Information</a>
          {whatsappHref && (
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--ghost-white"
            >
              WhatsApp Us
            </a>
          )}
          <a href="/#contact" className="btn btn--ghost-white">Book an Inspection</a>
        </div>

        <a href={formatPhoneHref(phone)} className="pd-enquire__phone">
          {phone}
        </a>
      </div>
    </section>
  );
}
